import styled from "styled-components"
import { phoneWidth } from "../Globalstyle"

const Container = styled.div`
  background-color: white;
  border: 0.2rem solid var(--green);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  min-width: ${props => props.wide ? "24rem" : "12rem"};
  gap: 1rem;

  @media (max-width: ${phoneWidth}) {
    min-width: auto;
  }
`

const Title = styled.div`
  font-size: 1.25rem;
  color: var(--green);
  font-weight: bold;
`

const Items = styled.ul`
  margin: 0;
  padding-left: 1.5rem;
  display: flex;
  flex-direction: column;
  height: 6rem;
  flex-wrap: wrap;
  column-gap: 1rem;

  @media (max-width: ${phoneWidth}) {
    height: auto;
  }
`

const Item = styled.li`
  line-height: 2rem;
`

const CarePackageDetails = ({title, items, wide=false}) => {
  return (
    <Container wide={wide}>
      <Title>
        {title}
      </Title>
      <Items>
        {
          items.map(item => (
            <Item key={item}>
              <strong>{item.split(" ")[0]}</strong>
              {" "}
              {item.split(" ").slice(1).join(" ")}
            </Item>
          ))
        }
      </Items>
    </Container>
  )
}

export default CarePackageDetails